import { RouteRecordRaw } from 'vue-router';
import { RouteNames } from './types';
import { useFeatureFlagsStore } from '@/features/feature-flags/presentation/bloc/feature-flags-bloc';
import { FeatureFlagKey } from '@/features';

export const routes: RouteRecordRaw[] = [
  {
    path: '',
    name: RouteNames.Hazards,
    component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
    children: [
      {
        path: ':hazardType',
        name: RouteNames.HazardByType,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
      },
      {
        path: ':hazardType/:hazardId',
        name: RouteNames.HazardById,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
        meta: { title: 'Hazard Details' },
      },
    ],
    meta: {
      title: 'Emergency WA Warnings & Incidents',
    },
  },
  {
    path: '/text-version',
    name: RouteNames.TextVersion,
    component: () => import('@/features/hazards/presentation/views/HazardTextVersion.vue'),
    meta: {
      title: 'Text version of warnings and incidents',
      description: 'View a text only version of alerts and warnings.',
    },
  },
  {
    path: '/text-version/:hazardType/:hazardId',
    name: RouteNames.TextVersionById,
    component: () => import('@/features/hazards/presentation/views/HazardTextSingle.vue'),
    meta: {
      title: 'Text version of warnings and incidents',
      description: 'View a text only version of alerts and warnings.',
    },
  },
  {
    path: '/about',
    component: () => import('@/common/views/about/About.vue'),
    meta: {
      title: 'About this site',
      description: 'Find out more about Emergency WA.',
    },
  },
  {
    path: '/map-icons',
    component: () => import('@/features/hazards/presentation/views/MapIcons.vue'),
    meta: {
      title: 'Map Icons',
    },
  },
  {
    path: '/map-guide',
    component: () => import('@/features/hazards/presentation/views/MapGuide.vue'),
    meta: {
      title: 'Map Guide',
    },
  },
  {
    path: '/plan',
    name: RouteNames.MyEmergencyPlan,
    component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
    beforeEnter: (_to, _from, next) => {
      const featureFlagsStore = useFeatureFlagsStore();
      if (featureFlagsStore.isEnabled(FeatureFlagKey.EnableMyEmergencyPlan)) {
        return next();
      }

      next({ name: RouteNames.Hazards });
    },
    meta: {
      title: 'Emergency Plan',
    },
  },
  {
    path: '/plan/redeem',
    name: RouteNames.MyEmergencyPlanRedeemInAppPlan,
    component: () => import('@/features/my-emergency-plan/presentation/components/views/UiMyEmergencyPlanRedeemInAppPlanView.vue'),
    beforeEnter: (_to, _from, next) => {
      const featureFlagsStore = useFeatureFlagsStore();
      if (featureFlagsStore.isEnabled(FeatureFlagKey.EnableMyEmergencyPlan)) {
        return next();
      }
      next({ name: RouteNames.Hazards });
    },
    meta: {
      title: 'Redeem plan link',
    },
  },
  // Redirect any unmatched routes to the hazards page
  {
    path: '/:pathMatch(.*)',
    redirect: {
      name: RouteNames.Hazards,
    },
  },
  // dummy routes for external links meta tags
  {
    path: '/aws',
    component: () => {},
    meta: {
      title: 'Australian Warning System',
      description: 'Know the warning levels for bushfire, cyclone, flood, storm and heatwave.',
    },
  },
  {
    path: '/prepare',
    component: () => {},
    meta: {
      title: 'Prepare',
      description: 'Helpful resources to prepare for emergencies.',
    },
  },
  {
    path: '/recovery',
    component: () => {},
    meta: {
      title: 'Recovery',
      description: 'Find recovery and assistance information after an emergency.',
    },
  },
  {
    path: '/faq',
    component: () => {},
    meta: {
      title: 'FAQ',
      description: 'Your Emergency WA questions answered.',
    },
  },
];
